<div class="h-full min-h-0" *transloco="let t">
  @if (ready() && breadcrumbLink(); as link) {
    <div appNavBreadcrumb class="flex min-w-0 items-center">
      <a iButton variant="ghost" class="min-w-0" [routerLink]="link" queryParamsHandling="merge">
        <span class="truncate">{{ strategyName() }}</span>
      </a>
    </div>
  }
  @if (!ready()) {
    <ISpinner [display]="true" main withTitle />
  } @else {
    @let creationForm = form();
    <app-form-shell>
      <div shellHeader>
        <IStepper [steps]="formSteps()" [form]="creationForm" (stepSelect)="goToStep($event)" clickable />
      </div>
      <div shellMain class="h-full min-h-0">
        @switch (currentStepId()) {
          @case ("setup") {
            <app-sb-form-setup
              [setup]="creationForm.setup"
              [hideName]="hideSetupNameAndAlgo()"
              [hideAlgo]="hideSetupNameAndAlgo()"
            />
          }
          @case ("format") {
            <app-sb-form-format
              [format]="creationForm.format"
              [selectedBrand]="creationForm.setup.brand().value()"
              [disableStoreSpotlight]="disableStoreSpotlight()"
              [disableManualCollection]="disableManualCollection()"
            />
          }
          @case ("assets") {
            <app-sb-form-assets
              [assets]="creationForm.assets"
              [creativeType]="creationForm.format.sbCreativeType().value()"
              [brandEntityId]="creationForm.setup.brand().value()?.brandEntityId"
              [defaultBrandName]="creationForm.setup.brand().value()?.brandName"
            />
          }
          @case ("creativesSbAsins") {
            <app-sb-creative-builder
              [creativesSbAsins]="creationForm.creativesSbAsins"
              [assets]="creationForm.assets"
              [creativeType]="creationForm.format.sbCreativeType().value()"
              [store]="creationForm.format.store().value()"
              [tacosSpAsins]="tacosSpAsins()"
            />
          }
        }
      </div>
      <div shellFooter class="flex items-center justify-between gap-3">
        <button iButton variant="secondary" type="button" [disabled]="isSubmitting()" (click)="cancel()">
          {{ t("common.cancel") }}
        </button>
        <div class="flex items-center gap-3">
          @if (!isFirstStep()) {
            <button iButton variant="secondary" type="button" [disabled]="isSubmitting()" (click)="back()">
              {{ t("common.back") }}
            </button>
          }
          @if (showRelaunchPreModeration()) {
            <button
              iButton
              variant="warning"
              type="button"
              [loading]="preModeration.loading()"
              testId="relaunch-premod-button"
              (click)="relaunchPreModeration()"
            >
              @if (!preModeration.loading()) {
                <IIcon name="circleArrows" />
              }
              {{ t("sb-form-creative.relaunch_pre-moderation") }}
            </button>
          }
          @if (isLastStep()) {
            <button
              iButton
              type="button"
              [disabled]="creationForm().invalid()"
              [loading]="isSubmitting()"
              testId="create-strategy-button"
              (click)="onSubmit()"
            >
              {{ t(submitLabelKey()) }}
            </button>
          } @else {
            <button
              iButton
              type="button"
              [disabled]="!canGoNext()"
              [loading]="preModeration.loading()"
              testId="next-button"
              (click)="next()"
            >
              {{ isSubmitting() ? t("dsp-create-strategy-page.creating_your_strategy") : t("common.next") }}
            </button>
          }
        </div>
      </div>
    </app-form-shell>
  }
</div>
